import React, { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import api from "@/lib/apiClient";
import { useLang } from "@/lib/i18n";
import { fmtWIB } from "@/lib/dateFmt";

export default function AdminAudit() {
  const { lang } = useLang();
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/audit-logs").then(r => setLogs(r.data)); }, []);
  return (
    <AdminLayout>
      <h1 className="font-display text-3xl tracking-tight mb-2">{lang === "id" ? "Log Audit" : "Audit Log"}</h1>
      <p className="text-muted-foreground text-sm mb-8">{lang === "id" ? "Riwayat semua tindakan admin." : "History of all admin actions."}</p>
      <div className="rounded-2xl border border-border bg-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-secondary/60 text-xs uppercase tracking-wider text-muted-foreground">
            <tr>
              <th className="text-left p-4">{lang === "id" ? "Waktu" : "Time"}</th>
              <th className="text-left p-4">{lang === "id" ? "Aktor" : "Actor"}</th>
              <th className="text-left p-4">{lang === "id" ? "Aksi" : "Action"}</th>
              <th className="text-left p-4">Entity</th>
              <th className="text-left p-4">IP</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {logs.map((l, i) => (
              <tr key={i} data-testid={`audit-row-${i}`}>
                <td className="p-4 text-xs text-muted-foreground">{fmtWIB(l.created_at, lang)}</td>
                <td className="p-4">
                  <div>{l.actor_username || l.actor_email}</div>
                  <div className="text-xs text-muted-foreground capitalize">{l.actor_role}</div>
                </td>
                <td className="p-4 font-mono text-xs">{l.action}</td>
                <td className="p-4 text-xs text-muted-foreground">{l.entity}{l.entity_id ? ` · ${l.entity_id.slice(0,8)}` : ""}</td>
                <td className="p-4 text-xs text-muted-foreground">{l.ip || "-"}</td>
              </tr>
            ))}
            {logs.length === 0 && (<tr><td colSpan={5} className="p-10 text-center text-muted-foreground">{lang === "id" ? "Belum ada log." : "No logs yet."}</td></tr>)}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
